import Main from '@/views/administracion/configuracion/catalogos/programasinversion/Main.vue';
import Default from '@/views/administracion/configuracion/catalogos/programasinversion/Default.vue';

const auth = ['Catálogos:ver'];
const scopes = ['Catálogos:crear', 'Catálogos:editar', 'Catálogos:eliminar'];

const programasInversion = [
  {
    path: 'programas-inversion',
    meta: {
      title: '',
      auth,
      scopes,
    },
    component: Main,
    children: [
      {
        name: 'catalogoProgramasInversion',
        path: '/',
        meta: {
          title: 'Programas de Inversion',
          auth,
          scopes,
        },
        component: Default,
      },
    ],
  },
];

export default programasInversion;
